import { Divider } from "element-ui";

export default[
    {
        show(row,extra){
            return(
                row.shbj==='8'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '待平台审核';
        }
    },
    {
        show(row,extra){
            return(
                row.shbj==='1'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '已提交待审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='0'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '未提交';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='9'||row.shbj==='6'
            )
        },
        tag:'my-tag',
        type:'success',
        text(row){
            return '已审核';
        }
    }

]